import { styled } from 'config/stitches/stitches';

export const Container = styled('header', {
  background: '$FILL_ACCENT_DEFAULT',
  paddingInline: '16px',
  paddingBlock: '8px',
  width: '100%',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'fixed',
  zIndex: 10,
});

export const LogoContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const Group = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const UserInfo = styled('div', {
  position: 'relative',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  borderRadius: '4px',
  paddingInline: '4px',
  height: '32px',
  minWidth: '145px',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: '1px solid $BORDER_NEUTRAL_DEFAULT',
    borderRadius: '4px',
    opacity: 0.3,
    pointerEvents: 'none',
  },
});

export const UserName = styled('h5', {
  fontWeight: 400,
  fontSize: 12,
  color: '$CONTENT_INVERSE',
  margin: 0,
  padding: 0,
});

export const Avatar = styled('img', {
  objectFit: 'contain',
  maxHeight: '24px',
  maxWidth: '24px',
  height: '24px',
  width: '24px',
});
